export default __webpack_public_path__ + "static/media/swn_coins.8713c9ab.jpg";